<template>
  <div :class="$style.box" @touchmove="closeIcon">
    <!-- 顶部大banner -->
    <div :class="$style.banner">
      <img :src="`${$cdnUrl}/freeKingdoms/bg_01.jpg?v=1`" alt="" />
      <img :src="`${$cdnUrl}/freeKingdoms/button_download.png?v=2`" alt="" @click="jump" />
    </div>
    <!-- 第一部分：绑定有礼 -->
    <div
      :class="$style.bind"
      :style="{ backgroundImage: `url('${$cdnUrl}/freeKingdoms/bg_02.jpg')` }"
    >
      <!-- 向下提示箭头 -->
      <div v-if="downIconShow" :class="$style.downIcon"></div>
      <p :class="$style.explain">
        绑定游戏账号即获得丰厚礼包，<span :style="{ color: '#fff', fontWeight: 'bold' }"
          >下滑解锁</span
        >签到积分玩法资格！
      </p>
      <p :class="$style.title">游戏账号</p>
      <!-- 绑定了账号 -->
      <div v-if="userInfo.game_account !== ''" :class="$style.account">
        <div></div>
        <div></div>
        <div>{{ userInfo.game_account }}</div>
      </div>
      <div
        v-if="userInfo.game_account !== ''"
        :class="$style.bindBtn"
        :style="{ backgroundImage: `url('${$cdnUrl}/freeKingdoms/button_get_04.png')` }"
        @click="getGift(0)"
      ></div>
      <!-- 未绑定账号 -->
      <div
        v-else
        :class="$style.bindBtn"
        :style="{
          backgroundImage: `url('${$cdnUrl}/freeKingdoms/button_bind.png')`,
          marginTop: '13px',
        }"
        @click="handleBind"
      ></div>
    </div>
    <!-- 第二部分：签到有礼 -->
    <div
      :class="$style.sign"
      :style="{ backgroundImage: `url('${$cdnUrl}/freeKingdoms/bg_03.jpg')` }"
    >
      <p>
        累计签到 <span>{{ signDay }}</span> 天
      </p>
      <div :class="$style.content">
        <div
          v-for="(item, index) in signList"
          :key="index"
          :style="{ backgroundImage: `url('${item.image}')` }"
          :class="`${item.sort <= signDay && getGiftIds.includes(item.id) ? $style.gary : null}`"
        >
          <!-- 右上角小icon -->
          <img
            v-if="item.sort <= signDay && !getGiftIds.includes(item.id)"
            :class="$style.icon"
            :src="`${$cdnUrl}/freeKingdoms/icon_get_01.png`"
          />
          <img
            v-if="item.sort <= signDay && getGiftIds.includes(item.id)"
            :class="$style.icon"
            :src="`${$cdnUrl}/freeKingdoms/icon_get_02.png`"
          />
          <!-- 底部按钮部分 -->
          <!-- 已领取 -->
          <img
            :class="$style.button"
            v-if="item.sort <= signDay && getGiftIds.includes(item.id)"
            :src="`${$cdnUrl}/freeKingdoms/button_get_01.png`"
            @click="getGift(item.sort)"
          />
          <!-- 可领取 -->
          <img
            :class="$style.button"
            v-if="item.sort <= signDay && !getGiftIds.includes(item.id)"
            :src="`${$cdnUrl}/freeKingdoms/button_get_02.png`"
            @click="getGift(item.sort)"
          />
          <!-- 不满足 -->
          <img
            :class="$style.button"
            v-if="item.sort > signDay"
            :src="`${$cdnUrl}/freeKingdoms/button_get_03.png?v=123`"
            @click="cantGet"
          />
        </div>
      </div>
      <!-- 底部签到按钮 -->
      <img
        v-if="todaySignIn === 0 && userInfo.game_account !== ''"
        :src="`${$cdnUrl}/freeKingdoms/button_sign_01.png`"
        @click="handleSign"
      />
      <img
        v-if="todaySignIn !== 0 && userInfo.game_account !== ''"
        :src="`${$cdnUrl}/freeKingdoms/button_sign_02.png`"
      />
    </div>
    <!-- 第三部分：积分奖励 -->
    <div
      :class="$style.ponitGift"
      :style="{ backgroundImage: `url('${$cdnUrl}/freeKingdoms/bg_04.jpg')` }"
    >
      <p>活动期间在《逍遥三国》中完成以下任务可获得相应奖励（充值金额不限）</p>
      <div :class="$style.content">
        <div v-for="(item, index) in ponitGiftList" :key="index">
          <div :class="$style.mask"></div>
          <div :class="$style.inner">
            <!-- 左部礼包icon -->
            <img :class="$style.icon" :src="`${$cdnUrl}/freeKingdoms/icon_gift_01.png`" />
            <p>
              累计充值 <span>{{ item.day }}</span> 天
              <span>{{ `(积分+${item.score_value})` }}</span>
            </p>
            <!-- 右部按钮部分 -->
            <!-- 已领取 -->
            <img
              v-if="scoreDay >= item.day && getScoreDay.includes(item.day)"
              :class="$style.button"
              :src="`${$cdnUrl}/freeKingdoms/button_get_05.png`"
            />
            <!-- 可领取 -->
            <img
              v-if="scoreDay >= item.day && !getScoreDay.includes(item.day)"
              :class="$style.button"
              :src="`${$cdnUrl}/freeKingdoms/button_get_06.png`"
              @click="handleGetScore(item.day)"
            />
            <!-- 不满足 -->
            <img
              v-if="scoreDay < item.day"
              :class="$style.button"
              :src="`${$cdnUrl}/freeKingdoms/button_get_07.png`"
              @click="$toast.fail('不满足领取条件')"
            />
          </div>
        </div>
      </div>
      <p :style="{ marginTop: '6px', fontSize: '10px' }">
        若任务完成但领取积分失败，请刷新页面后重试
      </p>
    </div>
    <!-- 第四部分：积分兑换 -->
    <div
      :class="$style.pointGet"
      :style="{ backgroundImage: `url('${$cdnUrl}/freeKingdoms/bg_05.jpg')` }"
    >
      <div :class="$style.info">
        <p>
          我的积分：<span>{{ surplusScore }}</span>
        </p>
        <p @click="handleRecord">兑换记录<span></span></p>
      </div>
      <div :class="$style.content">
        <div
          v-for="(item, index) in scoreList"
          :key="index"
          :style="{ backgroundImage: `url('${item.image}')` }"
          @click="handleScoreExchange(item.score_value, item.id)"
        >
          <!-- <img :src="item.icon" alt="" />
          <p>{{ item.description }}</p>
          <p>{{ item.score_value }}积分兑换</p> -->
        </div>
      </div>
    </div>
    <!-- 第五部分：活动规则 -->
    <div
      :class="$style.rule"
      :style="{ backgroundImage: `url('${$cdnUrl}/freeKingdoms/bg_06.jpg?v=1')` }"
    >
      <p>① 若在活动过程中遇到任何问题，请联系客服​。</p>
      <p>② 参与活动需先绑定游戏账号，才可领取签到奖励和积分奖励。</p>
      <p>③ 若提示绑定游戏账号失败，请确认：</p>
      <p :class="$style.inner">1. 账号和密码是否输入准确。</p>
      <p :class="$style.inner">2. 是否下载登录本平台对应游戏：逍遥三国</p>
      <p>④ 若游戏内输入礼包码，提示礼包兑换失败，请注意：</p>
      <p :class="$style.inner">1. 本活动礼包码仅限【逍遥三国】游戏使用。</p>
      <p :class="$style.inner">2. 每个累签礼包仅可领取一次，每个礼包仅能兑换一次</p>
      <p>⑤ 玩家领到礼包请及时兑换，避免逾期无法兑换，活动时间结束后将会无法查看礼包码。</p>
      <p>⑥ 礼包码有时间限制，请及时前往游戏内主界面【设置】-【礼包兑换】处进行兑换。</p>
      <p>⑦ 本活动最终解释权归官方所有。</p>
    </div>
    <!-- 礼包弹窗 -->
    <DialogGift
      v-show="dialogGiftShow"
      :title="dialogGiftTitle"
      :code="dialogGiftCode"
      :config="dialogGiftConf"
      @closeGift="closeGift"
    ></DialogGift>
    <!-- 积分兑换确定弹窗 -->
    <DialogScore
      v-show="dialogScoreShow"
      :scroe="currentScore"
      @closeScore="closeScore"
      @doScore="doScoreExchange"
    ></DialogScore>
    <!-- 兑换记录弹窗 -->
    <DialogRecord
      v-show="dialogRecordShow"
      :config="dialogRecordConf"
      @closeRecord="closeRecord"
    ></DialogRecord>
    <!-- 活动状态全局弹窗 -->
    <div v-if="state !== 1" :class="$style.outDialog" @touchmove.prevent>
      <div :class="$style.content">
        <div></div>
        <div></div>
        <div :class="$style.inner">
          <div :class="$style.top">提示</div>
          <div :class="$style.bot">
            <p>
              {{
                state === 0
                  ? '活动还未开始，超值奖励敬请期待！'
                  : '活动已结束，关注【逍遥】官方论坛，掌握最新福利活动！'
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DialogGift from './components/freeKingdoms/DialogGift.vue';
import DialogScore from './components/freeKingdoms/DialogScore.vue';
import DialogRecord from './components/freeKingdoms/DialogRecord.vue';
import {
  promoteRechargeCurrentInfo,
  promoteRechargeActInfo,
  promoteRechargeGetGift,
  promoteRechargeSignIn,
  promoteRechargeGetScore,
  promoteRechargeScoreExchange,
  promoteRechargeLog,
} from '@/api/activity';
import { mapState, mapMutations, mapActions } from 'vuex';
import { sortGift, scoreGift } from './components/freeKingdoms/config';
import { reportData } from '@/api/report';

export default {
  components: { DialogGift, DialogScore, DialogRecord },
  data() {
    return {
      state: 1, // 当前活动状态 0 未开启 1 进行中 2 已结束
      signDay: 0, // 累计签到天数
      signList: [
        { image: `${this.$cdnUrl}/freeKingdoms/sign_01.png`, sort: 1 },
        { image: `${this.$cdnUrl}/freeKingdoms/sign_02.png`, sort: 2 },
        { image: `${this.$cdnUrl}/freeKingdoms/sign_03.png`, sort: 3 },
        { image: `${this.$cdnUrl}/freeKingdoms/sign_04.png`, sort: 4 },
        { image: `${this.$cdnUrl}/freeKingdoms/sign_05.png`, sort: 5 },
        { image: `${this.$cdnUrl}/freeKingdoms/sign_06.png`, sort: 6 },
        { image: `${this.$cdnUrl}/freeKingdoms/sign_07.png`, sort: 7 },
      ], // 签到有礼礼包状态列表
      getGiftIds: [], // 已经获取的礼包ID合集（绑定游戏账号 + 签到）
      todaySignIn: 0, // 今日是否已签到 1：已签到
      getScoreDay: [], // 积分奖励已经领取列表 - 根据天数来
      ponitGiftList: [
        { score_value: 20, day: 1 },
        { score_value: 30, day: 3 },
        { score_value: 40, day: 5 },
        { score_value: 70, day: 7 },
        { score_value: 120, day: 10 },
      ], // 积分奖励列表
      scoreDay: 0, // 累计充值天数
      surplusScore: 0, // 我的积分
      scoreExchange: [], // 积分兑换已兑换的奖励ID
      scoreList: [
        { image: `${this.$cdnUrl}/freeKingdoms/point_01.png`, score_value: 20 },
        { image: `${this.$cdnUrl}/freeKingdoms/point_02.png`, score_value: 30 },
        { image: `${this.$cdnUrl}/freeKingdoms/point_03.png`, score_value: 40 },
        { image: `${this.$cdnUrl}/freeKingdoms/point_04.png`, score_value: 70 },
        { image: `${this.$cdnUrl}/freeKingdoms/point_05.png`, score_value: 120 },
      ], // 积分兑换列表
      dialogGiftShow: false, // 礼包弹窗显示
      dialogGiftTitle: '', // 礼包弹窗标题
      dialogGiftCode: '', // 礼包弹窗礼包码
      dialogGiftConf: [], // 礼包弹窗配置信息
      dialogScoreShow: false, // 积分兑换确认弹窗显示
      currentScore: 0, // 当前兑换的积分
      currentID: 0, // 当前兑换的id
      dialogRecordShow: false, // 兑换记录显示
      dialogRecordConf: [], // 兑换记录数据
      downIconShow: true, // 下滑箭头是否显示
    };
  },
  created() {
    this.getInfo();
    this.getUserInfo();
    reportData({ type: 13 });
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME',
    }),
    // 获取活动信息
    async getInfo() {
      const r = await promoteRechargeActInfo({});
      if (r.code !== 1) return;
      // 获取基本信息并且赋值
      const { bind, info, score, sign_in } = r.data;
      // 配置签到礼包 - 根据天数匹配
      this.signList.forEach((m) => {
        const obj = sign_in.filter((n) => {
          return n.sort === m.sort;
        })[0];
        obj && (m.id = obj.gift_id);
      });
      // 配置积分兑换礼包 - 根据积分匹配
      this.scoreList.forEach((m) => {
        const obj = score.filter((n) => {
          return n.score_value === m.score_value;
        })[0];
        if (obj) {
          m.welfare_id = obj.welfare_id;
          m.id = obj.id;
        }
      });
      this.state = info.state;
    },
    // 获取用户信息
    async getUserInfo() {
      const r = await promoteRechargeCurrentInfo();
      if (r.code !== 1) return;
      this.scoreDay = r.data.total_pay_day;
      this.todaySignIn = r.data.today_sign_in;
      this.signDay = r.data.total_sign_in_day;
      this.surplusScore = r.data.surplus_score;
      this.scoreExchange = r.data.score_exchange;
      this.getScoreDay = r.data.get_score_day;
      this.getGiftIds = r.data.get_gift_ids;
    },
    // 点击绑定账号
    handleBind() {
      this.CHANGE_BIND_GAME(true);
    },
    // 关闭礼包弹窗
    closeGift() {
      this.dialogGiftShow = false;
      this.dialogGiftTitle = '';
      this.dialogGiftCode = '';
      this.dialogGiftConf = [];
    },
    // 点击领取礼包
    async getGift(sort) {
      const r = await promoteRechargeGetGift({ sort: sort });
      if (r.code !== 1) return;
      this.dialogGiftShow = true;
      this.dialogGiftTitle = r.data.name;
      this.dialogGiftCode = r.data.gift_code;
      this.dialogGiftConf = sortGift[sort];
      // 刷新用户信息
      this.getUserInfo();
    },
    // 点击签到
    async handleSign() {
      const r = await promoteRechargeSignIn();
      if (r.code !== 1) return;
      this.$toast.success('签到成功');
      // 刷新用户信息
      this.getUserInfo();
    },
    // 点击不满足
    cantGet() {
      if (this.userInfo === '') {
        this.$toast.fail('不满足签到条件，请先绑定账号进行签到');
        return;
      }
    },
    // 点击领取积分
    async handleGetScore(day) {
      const r = await promoteRechargeGetScore({ recharge_days: day });
      if (r.code !== 1) return;
      this.$toast.success('领取成功');
      // 刷新用户信息
      this.getUserInfo();
    },
    // 点击积分兑换
    handleScoreExchange(score, id) {
      if (this.surplusScore < score) {
        this.$toast.fail('积分不足，去完成任务领取积分吧！');
        return;
      }
      this.dialogScoreShow = true;
      this.currentScore = score;
      this.currentID = id;
    },
    // 关闭确认积分兑换弹窗
    closeScore() {
      this.dialogScoreShow = false;
      this.currentScore = 0;
      this.currentID = 0;
    },
    // 积分兑换
    async doScoreExchange() {
      const r = await promoteRechargeScoreExchange({ id: this.currentID });
      if (r.code !== 1) return;
      this.dialogGiftShow = true;
      this.dialogGiftTitle = '积分兑换';
      this.dialogGiftCode = r.data.gift_code;
      this.dialogGiftConf = scoreGift[this.currentScore];
      this.closeScore();
      // 刷新用户信息
      this.getUserInfo();
    },
    // 获取兑换记录列表
    async handleRecord() {
      const r = await promoteRechargeLog();
      if (r.code !== 1) return;
      this.dialogRecordShow = true;
      this.dialogRecordConf = r.data;
    },
    // 关闭兑换记录
    closeRecord() {
      this.dialogRecordShow = false;
      this.dialogRecordConf = [];
    },
    // 点我下载
    jump() {
      // window.open('http://pop.ad.wxbz123.cn/Planlist/ad?id=61668ae1240df53b0f6d8a92', '_blank');
      this.$router.push({ name: 'gameCircle.home', query: { circleId: '24' } });
    },
    // 关闭icon
    closeIcon() {
      if (!this.downIconShow) return;
      this.downIconShow = false;
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  font-family: Microsoft YaHei;
  background-color: black;

  .banner {
    width: 100%;
    height: 421px;
    background-color: pink;
    position: relative;
    > img:nth-child(1) {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
    > img:nth-child(2) {
      width: 138px;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translateX(-50%);
      animation: notice 1.2s linear infinite;
    }
    @keyframes notice {
      0% {
        width: 128px;
      }
      50% {
        width: 148px;
      }
      100% {
        width: 128px;
      }
    }
  }

  .bind,
  .sign,
  .ponitGift,
  .pointGet,
  .rule {
    width: 100%;
    background-size: 100%;
    background-repeat: no-repeat;
    padding-top: 76px;
  }

  .bind {
    height: 258px;
    position: relative;
    .downIcon {
      width: 20px;
      height: 36px;
      background-color: rgba(255, 255, 255, 0.8);
      position: absolute;
      right: 10px;
      bottom: 70px;
      clip-path: polygon(8px 0px, 12px 0px, 12px 22px, 20px 22px, 10px 36px, 0px 22px, 8px 22px);
      animation: down 1.2s linear infinite;
    }
    @keyframes down {
      0% {
        bottom: 60px;
      }
      50% {
        bottom: 70px;
      }
      100% {
        bottom: 60px;
      }
    }
    .explain {
      width: 100%;
      height: 12px;
      font-size: 13px;
      font-weight: 400;
      color: #ffd87a;
      line-height: 19px;
      text-align: center;
      margin-bottom: 20px;
    }
    .title {
      width: 100%;
      height: 15px;
      font-size: 15px;
      font-weight: bold;
      color: #fffcb3;
      line-height: 19px;
      text-align: center;
    }
    .account {
      width: 141px;
      height: 39px;
      margin: 11px auto 6px auto;
      position: relative;
      > div:nth-child(1) {
        width: 133px;
        height: 39px;
        border: 1px solid #7a2500;
        position: absolute;
        left: 4px;
      }
      > div:nth-child(2) {
        width: 141px;
        height: 31px;
        border: 1px solid #7a2500;
        position: absolute;
        top: 4px;
      }
      > div:nth-child(3) {
        width: 137px;
        height: 35px;
        background: #7a2500;
        position: absolute;
        left: 2px;
        top: 2px;
        z-index: 2;
        font-size: 15px;
        font-weight: bold;
        color: #fff71c;
        line-height: 35px;
        text-align: center;
      }
    }
    .bindBtn {
      width: 120px;
      height: 34px;
      margin: 0 auto;
      background-repeat: no-repeat;
      background-size: 100%;
    }
  }

  .sign {
    height: 380px;
    position: relative;
    > p {
      width: 100%;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #691e00;
      line-height: 20px;
      > span {
        font-weight: bold;
        color: #f94000;
      }
    }
    > img {
      width: 105px;
      position: absolute;
      bottom: 32px;
      left: 50%;
      transform: translateX(-50%);
    }
    .content {
      width: 100%;
      min-height: 191px;
      display: flex;
      flex-wrap: wrap;
      padding: 0px 34px;
      justify-content: space-around;

      > div {
        width: 66px;
        height: 90px;
        background-repeat: no-repeat;
        background-size: 100%;
        margin-top: 16px;
        position: relative;
        .button {
          width: 66px;
          position: absolute;
          bottom: 5px;
        }
        .icon {
          width: 21px;
          position: absolute;
          top: 0;
          right: -10px;
        }
      }
      > div:nth-child(5) {
        margin-left: 34px;
      }
      > div:nth-child(7) {
        margin-right: 34px;
      }
      // 变灰
      .gary {
        filter: grayscale(100%);
      }
    }
  }

  .ponitGift {
    height: 395px;

    > p {
      width: 100%;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      color: #ffd87a;
      line-height: 18px;
      padding: 0px 38px;
    }

    .content {
      width: 100%;
      height: 203px;
      // background-color: pink;
      margin-top: 14px;

      > div {
        width: 330px;
        height: 31px;
        margin: 0px auto 12px auto;
        position: relative;
        .mask {
          width: 326px;
          height: 31px;
          border: 1px solid #ffab50;
          position: absolute;
          left: 2px;
        }
        .inner {
          width: 332px;
          height: 27px;
          background: #861b06;
          position: absolute;
          top: 2px;
          display: flex;
          align-items: center;
          justify-content: space-around;

          .icon {
            width: 18px;
            height: 17px;
            margin: 0px 7px;
          }
          > p {
            width: 210px;
            font-size: 14px;
            font-weight: 400;
            color: #fde298;
            line-height: 20px;
            > span:nth-child(1) {
              color: #01bb0f;
              font-weight: bold;
            }
            > span:nth-child(2) {
              font-size: 11px;
              font-weight: 400;
              color: #e2bf00;
            }
          }
          .button {
            width: 87px;
          }
        }
      }
    }
  }

  .pointGet {
    height: 401px;

    .info {
      width: 100%;
      height: 15px;
      display: flex;
      justify-content: space-between;
      padding: 0px 36px;
      font-size: 12px;
      font-weight: 400;
      color: #691e00;
      line-height: 15px;
      span {
        color: #f94000;
        font-weight: bold;
      }
      > p:nth-child(2) {
        color: #ec3d00;
        text-decoration: underline;
        > span {
          display: inline-block;
          width: 7px;
          height: 7px;
          border-color: #ec3d00;
          border-style: solid;
          border-width: 0 2px 2px 0;
          transform: rotateZ(-45deg);
        }
        &::after {
          content: '';
          display: inline-block;
          width: 5px;
          height: 5px;
          border-color: #ec3d00;
          border-style: solid;
          border-width: 0 2px 2px 0;
          transform: rotateZ(-45deg);
        }
      }
    }
    .content {
      width: 100%;
      height: 230px;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0px 50px;
      > div:nth-child(4) {
        margin: 20px 0px 0px 50px;
      }
      > div:nth-child(5) {
        margin: 20px 50px 0px 0px;
      }
      > div {
        width: 71px;
        height: 103px;
        background-repeat: no-repeat;
        background-size: 100%;
        font-size: 8px;
        font-weight: 400;
        color: #ffcc60;
        line-height: 10px;
        position: relative;
        > img {
          width: 45px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 8px;
        }
        > p:nth-child(2) {
          width: 100%;
          position: absolute;
          top: 53px;
          text-align: center;
        }
        > p:nth-child(3) {
          width: 100%;
          position: absolute;
          bottom: 8px;
          text-align: center;
          &::after {
            content: '';
            display: inline-block;
            width: 8px;
            height: 6px;
            background-color: #f2d9a1;
            clip-path: polygon(0px 2px, 4px 2px, 4px 0px, 8px 3px, 4px 6px, 4px 4px, 0px 4px);
            transform: translateX(2px);
          }
        }
      }
    }
  }

  .rule {
    height: 399px;
    font-size: 10px;
    font-family: FZDaBiaoSong-B06S;
    font-weight: 400;
    color: #f1e7b0;
    line-height: 18px;
    padding: 90px 38px 0px 38px;
    .inner {
      margin-left: 12px;
    }
  }
  .outDialog {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 20;
    .content {
      width: 300px;
      height: 187px;
      // background-color: pink;
      position: absolute;
      left: 50%;
      top: 220px;
      transform: translateX(-50%);
      > div:nth-child(1) {
        width: 282px;
        height: 100%;
        border: 1px solid #c2a67a;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      > div:nth-child(2) {
        width: 100%;
        height: 170px;
        border: 1px solid #c2a67a;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      .inner {
        width: 293px;
        height: 180px;
        border: 1px solid #c2a67a;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        background-color: #401f15;
        .top {
          width: 100%;
          height: 56px;
          background-color: #31170a;
          text-align: center;
          line-height: 56px;
          font-size: 23px;
          font-family: FZDaBiaoSong-B06S;
          font-weight: 400;
          color: #fff0b4;
        }
        .bot {
          width: 100%;
          height: 205px;
          position: relative;
          > p {
            width: 152px;
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #e8cf94;
            line-height: 25px;
            position: absolute;
            left: 50%;
            top: 22px;
            transform: translateX(-50%);
            text-align: center;
          }
        }
      }
    }
  }
}
</style>